exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".date-field.input-group--text-field.input-group--prepend-icon .input-group__details{max-width:calc(100% - 24px)}.date-field.input-group--text-field.input-group--prepend-icon .input-group__prepend-icon{min-width:36px}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/DateField.vue"],"names":[],"mappings":"AACA,oFACE,2BAA6B,CAC9B,AACD,yFACE,cAAgB,CACjB","file":"DateField.vue","sourcesContent":["\n.date-field.input-group--text-field.input-group--prepend-icon .input-group__details{\r\n  max-width: calc(100% - 24px);\n}\n.date-field.input-group--text-field.input-group--prepend-icon .input-group__prepend-icon {\r\n  min-width: 36px;\n}\r\n  \r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53627ea0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/DateField.vue
// module id = 807
// module chunks = 1